import DashboardTile from "./DashboardTile";
import { TILE_REGISTRY } from "./tileRegistry";

// Shared render helper used by DashboardPage (flat grid), DashboardSidebar,
// and DashboardQuadrant. Branches on whether the registry entry declares
// a custom `component` (e.g. MyTimeTile's pie chart) or the default
// `select` -> DashboardTile path. Returns null if the tile is hidden
// (visibility predicate failed) or the id is unknown.
export function renderTile(id, data, props, key) {
  const tile = TILE_REGISTRY[id];
  if (!tile) return null;
  if (!tile.visible(data, props)) return null;
  const onClick = props[tile.onClickKey];
  if (tile.component) {
    const Custom = tile.component;
    return <Custom key={key ?? id} data={data} onClick={onClick} />;
  }
  const { count, sublabel, htmlTitle } = tile.select(data);
  return (
    <DashboardTile
      key={key ?? id}
      title={tile.title}
      count={count}
      sublabel={sublabel}
      htmlTitle={htmlTitle}
      onClick={onClick}
    />
  );
}
